import { render, staticRenderFns } from "./MenuAccount_Main.vue?vue&type=template&id=5b6f8a1b&scoped=true"
var script = {}
import style0 from "./MenuAccount_Main.vue?vue&type=style&index=0&id=5b6f8a1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6f8a1b",
  null
  
)

export default component.exports